import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { ExtratoBancarioContasResponse } from '../../responses/financas/extrato-bancario-contas.response';
import { ImportarOfxRequest } from '../../requests/financas/importar-ofx.request';
import { ImportarOfxResponse } from '../../responses/financas/importar-ofx.response';
import { GetLancamentosRequest } from '../../requests/financas/get-lancamentos-conciliacao.request';
import { GetLancamentosResponse } from '../../responses/financas/get-lancamentos-conciliacao.response';
import { ConciliarRequest } from '../../requests/financas/conciliar.request';
import { BuscarParaAssociarRequest } from '../../requests/financas/buscar-para-associar.request';
import { BuscarParaAssociarResponse } from '../../responses/financas/buscar-para-associar.response';
import { RevisarEConciliarRequest } from '../../requests/financas/revisar-e-conciliar.request';
import { GetLancamentosIgnoradosRequest } from '../../requests/financas/get-lancamentos-ignorados.request';
import { RestaurarIgnoradosRequest } from '../../requests/financas/restaurar-ignorados.request';
import { GetLancamentosIgnoradosResponse } from '../../responses/financas/get-lancamentos-ignorados.response';
import { GetLancamentosConciliadosRequest } from '../../requests/financas/get-lancamentos-conciliados.request';
import { GetLancamentosConciliadosResponse } from '../../responses/financas/get-lancamentos-conciliados.response';
import { DesconciliarRequest } from '../../requests/financas/desconciliar.request';

@Injectable({ providedIn: 'root' })
export class ConciliacaoBancariaService extends CommonService {
  private readonly apiUrl = `${environment.urlApiFinancas}conciliacaobancaria/`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getContas(): Observable<ExtratoBancarioContasResponse> {
    return this.httpClient
      .get<ExtratoBancarioContasResponse>(`${this.apiUrl}contas`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public importarOfx(request: ImportarOfxRequest): Observable<ImportarOfxResponse> {
    return this.httpClient
      .post<ImportarOfxResponse>(`${this.apiUrl}importarExtrato`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getLancamentos(request: GetLancamentosRequest): Observable<GetLancamentosResponse> {
    return this.httpClient
      .post<GetLancamentosResponse>(`${this.apiUrl}getLancamentos`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public conciliar(request: ConciliarRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}conciliar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public buscarParaAssociar(request: BuscarParaAssociarRequest): Observable<BuscarParaAssociarResponse> {
    return this.httpClient
      .post<BuscarParaAssociarResponse>(`${this.apiUrl}buscarParaAssociar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public revisarEConciliar(request: RevisarEConciliarRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}revisar-e-conciliar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public ignorarLancamento(idExtratoBancario: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}ignorar/idExtratoBancario/${idExtratoBancario}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getLancamentosIgnorados(request: GetLancamentosIgnoradosRequest): Observable<GetLancamentosIgnoradosResponse> {
    return this.httpClient
      .post<GetLancamentosIgnoradosResponse>(`${this.apiUrl}getLancamentosIgnorados`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public restaurarIgnorados(request: RestaurarIgnoradosRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(`${this.apiUrl}restaurarIgnorados`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getLancamentosConciliados(request: GetLancamentosConciliadosRequest): Observable<GetLancamentosConciliadosResponse> {
    return this.httpClient
      .post<GetLancamentosConciliadosResponse>(`${this.apiUrl}getLancamentosConciliados`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public desconciliar(request: DesconciliarRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}desconciliar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}

